import React from "react";

import { Button, Tooltip } from "antd";
import { useHistory } from "react-router-dom";

import { getUsageMetricsBuildPlanPath } from "../../MyAccount/UsageMetrics/constants";

import { canMakePayment } from "../../../utils/Permissions";
import { canViewUsageMetrics } from "../../MyAccount/UsageMetrics/utils";

import { ReactComponent as CoinsIcon } from "../../../assets/images/subscriptions/coins-fill.svg";
import { ReactComponent as MicroscopeIllustration } from "../../../assets/images/subscriptions/Microscope.svg";

import "./NoTestCreditsEmptyState.css";

const USAGE_METRICS_PERMISSION_TOOLTIP = "Requires Usage Metrics Permission";

export default function NoTestCreditsEmptyState() {
  const history = useHistory();
  const allowPayment = canMakePayment();
  const allowUsageMetrics = canViewUsageMetrics();
  const buyCreditsDisabled = !allowUsageMetrics;

  return (
    <section className="NoTestCreditsEmptyState">
      <div className="NoTestCreditsEmptyState__Content">
        <h1 className="NoTestCreditsEmptyState__Heading">No Test Credits Available</h1>
        <p className="NoTestCreditsEmptyState__Text">
          {allowPayment
            ? "Purchase test credits to start submitting samples."
            : "Contact your account admin to purchase test credits."}
        </p>
        {allowPayment && (
          <Tooltip
            title={buyCreditsDisabled ? USAGE_METRICS_PERMISSION_TOOLTIP : ""}
            placement="right"
          >
            <span className="NoTestCreditsEmptyState__ButtonWrap">
              <Button
                type="primary"
                className="NoTestCreditsEmptyState__Button"
                icon={<CoinsIcon aria-hidden />}
                disabled={buyCreditsDisabled}
                onClick={() => history.push(getUsageMetricsBuildPlanPath())}
              >
                Buy Test Credits
              </Button>
            </span>
          </Tooltip>
        )}
      </div>

      <div className="NoTestCreditsEmptyState__Illustration" aria-hidden>
        <MicroscopeIllustration />
      </div>
    </section>
  );
}
